import React from 'react'
import styled from 'styled-components'

import theme from '../theme'

interface LogoProps {
  simple?: boolean
  onClick: () => void
  readonly inverted: boolean
  readonly navigating: boolean
}

const Logo = (props: LogoProps) => (
  <>
    <Mark {...props} width="40px" height="37px" viewBox="0 0 49 37">
      <path
        d="M8.052 24.94c0-.13 1.818-.39 2.467-.39 3.502 0 5.32 1.947 5.32 2.077 0 .13-.13.13-.13.13-.39 0-4.545-1.56-7.66-1.818.13.124 0 0 0 0m8.96-4.29c0 .13-.13.13-.13.13-.13 0-1.688-.78-2.857-1.43-1.558-.65-3.247-1.04-3.247-1.04 2.986-.39 4.934.52 5.973 2.08.13.13.26.13.26.26m.52-5.846c0 .13-.26.13-.26.13s-1.947-1.43-3.766-2.727c-.13 0-.13-.13-.13-.13 2.338.26 4.027 1.556 4.156 2.725m4.678.26c.52-1.818 2.597-2.598 4.026-2.728h.26c-.39.78-2.858 1.428-4.156 2.987 0-.13-.13-.13-.13-.26m7.013 3.118c-.26.26-3.764.91-6.102 2.73 0 0-.13-.13-.13-.26 1.558-2.86 5.325-2.47 6.234-2.47M24.03 26.62s1.687-2.597 6.492-2.467c.26 0 .91.13 1.166.13 0 0 .13.13-.26.13-1.428.13-4.805 1.558-5.454 1.947-.52.26-1.558.65-1.948.65-.13 0-.13-.13 0-.39m12.726 4.68c-1.688 1.43-6.493 2.598-9.74 2.598-.65 0-1.3 0-1.818-.13-.39 0-.78-.13-1.17-.26-.39-.13-1.557-.388-2.207-1.298-.39-.65-.91-2.468.13-3.247 1.558-1.3 3.117.26 5.065 0 4.675-.52 4.545-3.377 7.922-5.195-6.234-1.69-11.3.39-12.467 2.727-1.04 1.95-1.56 1.17-1.56.52v-1.56c0-.648 0-2.077 1.17-2.856 1.17-.78 1.428-.26 3.896-.39 3.507-.26 4.026-3.38 6.104-4.81-2.078.13-7.533-2.207-10.26 3.508-.13.39-.78.78-1.04 1.17 0-2.21-.13-2.858 0-3.768 0-.52.39-1.948 1.17-2.078.52-.13 1.688-.13 2.338-.26 1.688-.39 3.636-2.208 3.506-4.806-1.424.65-5.19-.52-6.62 3.895-.13.26-.39 1.04-.52 1.3 0-.52-.26-3.377-.13-4.546.13-.13 2.598-2.08.91-5.067-.65-1.3-1.56-2.857-1.56-2.857s-.91 1.558-1.56 2.857c-1.69 2.99.78 4.937.91 5.067v3.896c-.13 1.04-.65-1.56-1.3-2.468-.78-1.04-1.685-1.69-3.244-1.82-.91-.13-1.04 0-2.597-.26 1.817 5.716 4.544 4.676 6.103 5.066.65.13.91 1.56 1.04 2.21.13.91 0 3.507 0 3.507-1.17-.65-2.6-5.065-6.104-4.806-2.728.13-4.806 0-4.936-.13 1.82 3.12 3.12 5.976 8.963 5.066 1.17-.13 1.82 1.69 1.95 2.08.13.65.13 1.688 0 2.857-.13 1.17-.78.13-1.56-.52-.65-.78-3.376-3.507-8.05-2.857-2.6.39-2.21.26-4.417 0 1.04 1.3 3.895 7.144 9.22 4.806 2.987-1.3 5.195.65 4.026 3.636-.26.65-1.04 1.17-2.338 1.56-.39.13-.65.13-1.04.26H12.73c-2.207 0-5.064-.52-7.27-1.3-1.04-.39-1.95-.91-2.6-1.3-.52-.52-.78-.91-.78-1.04 0-4.935 2.73-11.43 6.495-16.884 3.51-5.198 8.054-9.614 11.17-10.913 3.118 1.3 7.534 5.586 11.17 10.91 3.766 5.457 6.494 11.95 6.494 16.887.13.26 0 .65-.65 1.04M20.13 11.04c-.13 0-.39-.26-.39-.26s0-.78.13-1.688c.13-1.3 0-3.117.13-2.987.39.39.78 2.338.65 2.987 0 .52-.13 1.95-.52 1.95m12.857 1.038C29.09 6.365 24.417 1.69 20.26.13L19.87 0l-.39.13c-4.025 1.56-8.7 6.235-12.597 11.95C2.987 17.795 0 24.55 0 30.264c0 1.17.78 2.208 1.558 2.858 2.598 2.078 7.403 3.117 11.3 3.117.778 0 1.558 0 2.207-.13 2.338-.39 4.286-1.04 4.935-.91.65 0 2.468.52 4.935.91.65.13 1.43.13 2.208.13 2.597 0 5.584-.52 8.052-1.43 1.3-.52 2.337-1.04 3.247-1.69.91-.65 1.558-1.69 1.558-2.86-.13-5.715-3.117-12.47-7.013-18.184"
        fill="#000000"
        fillRule="evenodd"
      />
    </Mark>
    {props.simple ? null : <Title {...props}>Ligonier Ministries</Title>}
  </>
)

const Mark = styled.svg<LogoProps>`
  cursor: pointer;
  left: 0;
  position: fixed;
  top: 2px;
  transform: scale(0.6);
  z-index: ${(p) => p.theme.index.logoMark};
  @media (min-width: ${(p) => p.theme.breakpoints.small}) {
    left: 25px;
    top: 25px;
    transform: scale(1);
  }
  path {
    fill: ${(p) => (p.inverted ? p.theme.colors.white : p.theme.colors.black)};
    transition: ${(p) => p.theme.transition};
  }
`

const Title = styled.p<LogoProps>`
  display: none;
  @media (min-width: ${(p) => p.theme.breakpoints.large}) {
    color: ${(p) => (p.inverted ? p.theme.colors.white : p.theme.colors.black)};
    cursor: pointer;
    display: block;
    font-size: 10px;
    font-weight: 600;
    left: 90px;
    letter-spacing: 0.35em;
    opacity: ${(p) => (p.navigating ? '1' : '0')};
    position: fixed;
    right: auto;
    text-align: left;
    text-transform: uppercase;
    top: 38px;
    transition: ${(p) => p.theme.transition};
    z-index: ${(p) => p.theme.index.logoTitle};
  }
`

export default Logo
